module.exports = __webpack_public_path__ + "static/img/mljwy.d3cb1290.jpg";